import React, { useContext, useEffect } from "react";
import {
  EducationForm,
  MiscForm,
  PersonalDetailsForm,
  ProfessionalExperienceForm,
  SkillsForm,
  SocialForm,
} from "..";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { doc, setDoc } from "firebase/firestore";
import styles from "./UserForm.module.css";
import "./UserForm.css";
import { Button } from "../../components";
import { ResumeContext } from "../../contexts/resumeContext";
import { ChevronLeft, ChevronRight } from "../../components/Icons/Icons";
import { db } from "../../firebase";
import { UserContext } from "../../contexts/userContext";

const sectionList = [
  "personal",
  "education",
  "employment",
  "skills",
  "social",
  "misc",
];

function UserForm() {
  const { resumeInfo, setResumeInfo, documentDataRef } =
    useContext(ResumeContext);
  const { user } = useContext(UserContext);

  const [searchParams, setSearchParams] = useSearchParams();
  const activeSection = searchParams.get("section");

  useEffect(() => {
    if (Object.keys(resumeInfo).length == 0) {
      setSearchParams({ section: "personal" });
    }
  }, [resumeInfo]);

  const sectionMap = {
    personal: <PersonalDetailsForm />,
    education: <EducationForm />,
    employment: <ProfessionalExperienceForm />,
    skills: <SkillsForm />,
    social: <SocialForm />,
    misc: <MiscForm />,
  };

  useEffect(() => {
    document.querySelector(".userForm")?.scrollTo(0, 0);
  }, [activeSection]);

  const handleNext = () => {
    updateDocData();
    const activeSectionIndex = sectionList.indexOf(activeSection);
    const nextSection = sectionList[activeSectionIndex + 1];
    if (nextSection) {
      setSearchParams({ section: nextSection });
    }
  };

  const handlePrev = () => {
    updateDocData();
    const activeSectionIndex = sectionList.indexOf(activeSection);
    const prevSection = sectionList[activeSectionIndex - 1];
    if (prevSection) {
      setSearchParams({ section: prevSection });
    }
  };

  const updateDocData = async () => {
    await setDoc(doc(db, "documentData", documentDataRef), {
      ...resumeInfo,
      user: user.uid,
    });
  };

  return (
    <div className="userForm">
      <Link to="/" className={styles.backBtn}>
        <ChevronLeft /> My Resumes
      </Link>
      {sectionMap[activeSection]}
      <div className={styles.row}>
        <Button
          outlined
          disabled={sectionList.indexOf(activeSection) === 0}
          content={
            <>
              <ChevronLeft />
              &nbsp;Previous
            </>
          }
          onClick={handlePrev}
        />
        {sectionList.indexOf(activeSection) >= sectionList.length - 1 ? (
          <Button
            content={
              <>
                Preview &amp; Download <ChevronRight />
              </>
            }
            onClick={() => {
              updateDocData();
              setSearchParams({ section: "preview" });
            }}
          />
        ) : (
          <Button
            disabled={
              sectionList.indexOf(activeSection) >= sectionList.length - 1
            }
            content={
              <>
                Next&nbsp;
                <ChevronRight />
              </>
            }
            onClick={handleNext}
          />
        )}
      </div>
      {!(sectionList.indexOf(activeSection) >= sectionList?.length - 1) && (
        <Button
          className={styles.mobilePreview}
          content={
            <>
              Preview &amp; Download <ChevronRight />
            </>
          }
          onClick={() => {
            updateDocData();
            setSearchParams({ section: "preview" });
          }}
        />
      )}
    </div>
  );
}

export default UserForm;
